export const SIGNIN = 'SIGNIN';
export const AUTHENTICATED = 'AUTHENTICATED';
export const SIGNOUT = 'SIGNOUT';
export const SIGNOUT_SUCCESS = 'SIGNOUT_SUCCESS';
export const SIGNUP = 'SIGNUP';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SHOW_AUTH_MESSAGE = 'SHOW_AUTH_MESSAGE';
export const HIDE_AUTH_MESSAGE = 'HIDE_AUTH_MESSAGE';
export const SHOW_LOADING = 'SHOW_LOADING';
export const SET_LOADING = 'SET_LOADING';
export const AUTH_TOKEN = 'AUTH_TOKEN';
export const IS_2FA_ENABLED = 'IS_2FA_ENABLED';
export const ACCESS_TOKEN = 'access_token';
export const SIGNIN_WITH_GOOGLE = 'SIGNIN_WITH_GOOGLE';
export const SIGNIN_WITH_GOOGLE_AUTHENTICATED =
  'SIGNIN_WITH_GOOGLE_AUTHENTICATED';
export const SIGNIN_WITH_FACEBOOK = 'SIGNIN_WITH_FACEBOOK';
export const SIGNIN_WITH_FACEBOOK_AUTHENTICATED =
  'SIGNIN_WITH_FACEBOOK_AUTHENTICATED';
export const SIGNIN_WITH_EMAIL = 'SIGNIN_WITH_EMAIL';
export const SIGNIN_WITH_EMAIL_AUTHENTICATED =
  'SIGNIN_WITH_EMAIL_AUTHENTICATED';
export const GENERATE_QR = 'GENERATE_QR';
export const SET_QR = 'SET_QR';
export const SET_UNIQUE_KEY = 'SET_UNIQUE_KEY';
export const VERIFY_UNIQUE_KEY = 'VERIFY_UNIQUE_KEY';
export const USER_VERIFIED = 'USER_VERIFIED';
export const RESET_USER_VERIFICATION = 'RESET_USER_VERIFICATION';
export const SET_TOKEN = 'SET_TOKEN';
export const EMAIL = 'EMAIL';
export const GET_IS_2FA_ENABLED = 'GET_IS_2FA_ENABLED';
export const SET_IS_2FA_ENABLED = 'SET_IS_2FA_ENABLED';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const GET_USER_PROFILE = 'GET_USER_PROFILE';
export const SET_USER_PROFILE = 'SET_USER_PROFILE';
